/** Formatter dùng chung cho cả `apps/web` và `apps/admin`. */

/**
 * Format giá VND. `price` lưu trong DB là **số nguyên VND** (CLAUDE.md §3).
 *
 * `formatVND(250000)` → `"250.000₫"`
 */
export function formatVND(price: number | null | undefined): string {
  if (price == null || Number.isNaN(price)) return 'Liên hệ'
  return (
    new Intl.NumberFormat('vi-VN', {
      style: 'currency',
      currency: 'VND',
      maximumFractionDigits: 0,
    })
      .format(price)
      // `Intl` chèn NBSP trước ₫ ("250.000 ₫"); `homepage.png` không có khoảng
      // trắng đó, nên bỏ đi để khớp thiết kế.
      .replace(/ /g, '')
  )
}

/** `formatDateVN('2026-09-07')` → `"07/09/2026"` — định dạng ngày hiển thị ở admin. */
export function formatDateVN(date: string | Date | null | undefined): string {
  if (!date) return ''
  const d = typeof date === 'string' ? new Date(date) : date
  if (Number.isNaN(d.getTime())) return ''
  return new Intl.DateTimeFormat('vi-VN', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(d)
}

/**
 * Bỏ dấu tiếng Việt + lowercase — dùng để so khớp keyword không phân biệt dấu.
 * Cùng logic với `./seo.ts` (`analyzeSeo`) để điểm SEO trong admin
 * và kết quả tìm kiếm ở frontend không lệch nhau.
 */
export function normalizeVi(input: string): string {
  return input
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D')
    .toLowerCase()
    .trim()
}

/** Sinh slug từ tiêu đề tiếng Việt. `"Đèn nhà nhỏ"` → `"den-nha-nho"`. */
export function slugifyVi(input: string): string {
  return normalizeVi(input)
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
}

/** Ước lượng thời gian đọc (phút) — dùng cho card blog. ~200 từ/phút. */
export function readingTime(text: string | null | undefined): number {
  if (!text) return 1
  const words = text.trim().split(/\s+/).length
  return Math.max(1, Math.round(words / 200))
}
